<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bus SOS Manager</span><br/>
      <span style="font-style: italic; font-size: 18px">manage Bus SOS requests you have sent or received</span>
    </div>
    <div style="margin:20px">
      <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">

        <date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>
        &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"></date-picker>&nbsp;&nbsp;
        <b-button variant="success" v-on:click.prevent="load_data()">Find Events</b-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span v-if="summary.aws_phone_number" >
          Send SOS: <b-form-input style="display: inline !important; width: 120px" v-model="sos_vehicle_name" placeholder="vehicle name"/>&nbsp;<b-form-input style="display: inline !important; width: 130px" v-model="sos_request_notes" placeholder="request notes"/>
         &nbsp;<b-button variant="success" v-on:click.prevent="send_sos_request()">Send</b-button>
          &nbsp;|&nbsp;&nbsp;
        </span>
        <b-button variant="" @click="manage_sos_yards = !manage_sos_yards">Yards</b-button>
        &nbsp;&nbsp;|&nbsp;&nbsp;<b-button variant="" @click="view_sos_partners = !view_sos_partners">Companies</b-button>
      </div>
      <div v-if="summary.aws_phone_number" style="font-size:18px; font-weight:bold; margin:10px">
        to kickoff a request, text 'SOS [vehicle name], [notes]' to #{{summary.aws_phone_number | prettyPhoneNumber}}
      </div>
      <br/>
      <b-table sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="internal_vehicle_details" slot-scope="row">
          <span v-if="row.item.internal_vehicle_details">{{row.item.internal_vehicle_details.length}}</span>
        </template>

        <template slot="internal_yard_details" slot-scope="row">
          <span v-if="row.item.internal_yard_details">{{row.item.internal_yard_details.length}}</span>
        </template>

        <template slot="registered_yard_details" slot-scope="row">
          <span v-if="row.item.registered_yard_details">{{row.item.registered_yard_details.length}}</span>
        </template>

        <template slot="external_yard_details" slot-scope="row">
          <span v-if="row.item.external_yard_details">{{row.item.external_yard_details.length}}</span>
        </template>

        <template slot="view" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails">Message</b-button>&nbsp;
          <b-button size="sm" :to="{ path: 'sos_detail?request_id=' + row.item.request_id}"><span style="color:white">Map View</span></b-button>&nbsp;
        </template>

        <template slot="manage" slot-scope="row">
          <b-button size="sm" @click="cancel_request(row.item.request_id)">Cancel</b-button>&nbsp;
          <b-button size="sm" @click="delete_request(row.item.request_id)">Delete</b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <table class="sos-msg-table" border="1" width="100%">
            <tr>
              <td style="font-size: 20px; font-weight: bold">Email Message</td>
              <td style="font-size: 20px; font-weight: bold">SMS Message</td>
            </tr>
            <tr>
              <td><pre class="sos-msg">{{row.item.email_msg}}</pre></td>
              <td><pre class="sos-msg">{{row.item.sms_msg}}</pre></td>
            </tr>
          </table>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-modal title="SOS Enabled Companies" size="lg" v-model="view_sos_partners" ok-only>
      <span v-if="summary.aws_phone_number">
        <b>Your SOS requests will be sent to these companies:</b><br/>
        <span v-for="sos_request_receiver in summary.sos_request_receivers">
          &nbsp;&nbsp;{{sos_request_receiver}}<br/>
        </span>
        <br/>
      </span>
      <b>You can receive SOS requests from these companies:</b><br/>
      <span v-for="sos_request_sender in summary.sos_request_senders">
        &nbsp;&nbsp;{{sos_request_sender}}<br/>
      </span>
    </b-modal>


    <b-modal title="Your Bus Yards" size="xl" v-model="manage_sos_yards" ok-only>
      <b>Get notified when vehicles request help near these bus yards.</b><br/><br/>
      <b-table v-if="summary.vehicle_yards" :items="summary.vehicle_yards" :fields="['yard_name','address','contact_name','phone','email']">
        <template slot="address" slot-scope="row">
          <a target='_blank' :href="'https://www.google.com/maps/search/?api=1&query=' + row.item.lat + ',' + row.item.lon">{{row.item.address}}</a>
        </template>
      </b-table>
    </b-modal>
  </div>

</template>

<script>

import {delete_sos_request, cancel_sos_request, get_sos_history, send_sos_request} from '../networking/apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";

export default {
  name: 'sos_list',
  components: {
  },

  data() {
    return {
      add_yard_error: null,
      add_yard_model: {},
      view_sos_partners: false,
      manage_sos_yards: false,
      toggle: {},
      items: [],
      items_full: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment().add(-31, 'days')),
      details_toDate: justDate(moment()),
      sos_vehicle_name: '',
      sos_request_notes: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields: [
        { key: 'source_tenant_name', label: 'SOS Company', sortable: true},
        { key: 'source_vehicle_name', label: 'SOS Vehicle', sortable: true},
        { key: 'request_notes', label: 'Request Notes', sortable: true},
        { key: 'processed_time', label:'Event Time', sortable: true},
        { key: 'internal_vehicle_details', label:'Nearby Vehicles', sortable: true},
        { key: 'internal_yard_details', label:'Nearby Yards', sortable: true},
        { key: 'registered_yard_details', label:'Registered Yards', sortable: true},
        { key: 'email_recipients', label:'Emailed To', sortable: true},
        { key: 'sms_recipients', label:'SMS Sent To', sortable: true},
        { key: 'sos_status', label: 'Status', sortable: true},
        { key: 'view', label: 'Event Details', sortable: false},
        { key: 'manage', label: 'Manage', sortable: false},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    await this.load_data()
  },
  methods: {
    async send_sos_request() {
      if (this.sos_vehicle_name) {
        this.$emit('showAlert', "sending SOS request for vehicle " + this.sos_vehicle_name, 'info', 10000)
        await send_sos_request(this.user.tenant, this.sos_vehicle_name, this.sos_request_notes)
        this.$emit('showAlert', "successfully sent SOS request for vehicle " + this.sos_vehicle_name, 'success', 5000)
        await this.load_data()
      }
    },
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_sos_history(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.events
        this.items_full = data.events
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    get_row_color(item, type) {
      if (!item || type !== 'row') return
      return item.status
    },
    async cancel_request(request_id) {
      this.$emit('showAlert', "cancelling request...", 'info')
      const result = await cancel_sos_request(this.user.tenant,request_id)
      this.$emit('showAlert', "request has been cancelled", 'success', 5000)
      await this.load_data()
    },
    async delete_request(request_id) {
      this.$emit('showAlert', "deleting request...", 'info')
      const result = await delete_sos_request(this.user.tenant,request_id)
      this.$emit('showAlert', "request has been deleted", 'success', 5000)
      await this.load_data()
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.sos-msg-table td {
  vertical-align: top !important;
  text-align: left !important;
}

.sos-msg {
  vertical-align: top !important;
  text-align: left !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

</style>

